import React from "react";
import "./SlasEscalationSection.css";

const SlasEscalationSection = () => {
  return (
    <section className="_sESec_z1A_">
      <div className="_sCont_a2B_">
        <h2
          className=" _hTitle_s5E_ workflow-title"
          style={{ marginBottom: "1.6rem", paddingBottom: "1.6rem" }}
        >
          Service Levels & Escalation
        </h2>
        <div className="_sEGrid_c4D_">
          <div className="_cCard_d5E_ sla-column">
            <h4 className="_cHead_e6F_">Our SLAs</h4>
            <ul className="_sList_f7G_">
              <li>
                Acknowledge: <strong>10 min</strong>
              </li>
              <li>
                First reply: <strong>2 hr</strong>
              </li>
              <li>
                Resolution: <strong>2 business days</strong>
              </li>
              <li>
                Critical: <strong>&lt;4 hr</strong>
              </li>
            </ul>
          </div>

          <div className="_cCard_d5E_ escalation-column">
            <h4 className="_cHead_e6F_">Escalation Path</h4>
            <ul className="_eList_g8H_">
              <li>Level 1: Support Agent/Volunteer</li>
              <li>Level 2: Seller/Community Manager</li>
              <li>Level 3: Platform Admin</li>
              <li>Level 4: Compliance/Legal</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SlasEscalationSection;
